import {Card} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import Level3Title from '../../../../app/common/components/title/Level3Title';

const VpnSecurityAdvice = (): JSX.Element => {
  const intl = useIntl();
  return (
    <Card className="mb-4">
      <Card.Header>
        <Card.Title>
          <Level3Title title={intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.ADVICE_TITLE'})} />
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <div className="alert alert-warning">
          <i className="fa-solid fa-triangle-exclamation me-2" />
          {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.WARNING'})}
        </div>
        <details className="mb-3">
          <summary className="fw-semibold cursor-pointer">
            {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.ADVICE_SECURITY'})}
          </summary>
          <ul className="mt-3">
            <li>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.ADVICE_SECURITY_1'})}</li>
            <li>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.ADVICE_SECURITY_2'})}</li>
            <li>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.ADVICE_SECURITY_3'})}</li>
          </ul>
        </details>
        <details>
          <summary className="fw-semibold cursor-pointer">
            {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.ADVICE_PERF'})}
          </summary>
          <ul className="mt-3">
            <li>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.ADVICE_PERF_1'})}</li>
            <li>{intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.VPN.ADVICE_PERF_2'})}</li>
          </ul>
        </details>
      </Card.Body>
    </Card>
  );
};

export default VpnSecurityAdvice;
